'use client'

import { toast } from 'react-toastify'
import { Button } from './Button'

export function Toast({ message }) {
  return (
    <div className="flex w-full items-center justify-between gap-8">
      <p className="flex-1 text-sm font-medium">{message}</p>

      <Button variant="ghost" size="sm" fontWeight="medium" onClick={() => toast.dismiss()}>
        Sluiten
      </Button>
    </div>
  )
}
